import groq from 'groq'

export default groq`{
  ...,
  "metadata": asset->metadata.dimensions
}`
